import { AlertTriangle, X } from "lucide-react";

export function RateLimitBanner({
  message,
  onDismiss,
  retryAfter,
}: {
  message: string;
  onDismiss: () => void;
  retryAfter: number;
}) {
  return (
    <div className="fixed right-4 top-16 z-50 max-w-md rounded-xs border-[1.2px] border-mef-red bg-mef-red-tint p-4 shadow-mef-popup">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-mef-red" />
        <div className="flex-1">
          <h4 className="mb-1 text-[11px] font-medium uppercase tracking-[0.04em] text-mef-red">
            Rate limit exceeded
          </h4>
          <p className="text-[13px] leading-4 text-black/80">{message}</p>
          <p className="mt-1 text-[11px] leading-4 text-black/60">
            Try again in {retryAfter}s, or sign in for a higher tier.
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="text-mef-red hover:text-mef-red-hover mef-focus-ring"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
